import { apiDelete } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";

/**
 * 사용자 삭제 API 함수
 * @param id 삭제할 사용자의 ID
 * @returns API 응답
 */
export const apiDeleteUser = async (id: string) => {
  const response = await apiDelete(`/users/${id}`);
  return response;
};

/**
 * 사용자 삭제 React Query 훅
 * @returns 뮤테이션 객체
 */
export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => apiDeleteUser(id),
    onSuccess: (_, id) => {
      // 전체 사용자 목록 무효화
      queryClient.invalidateQueries({ queryKey: QueryKeys.user.all });
      queryClient.invalidateQueries({ queryKey: QueryKeys.user.list() });
      // 삭제된 사용자 상세 정보 무효화
      queryClient.invalidateQueries({ queryKey: QueryKeys.user.detail(id) });
    },
  });
};

export default useDeleteUser;
